import React from 'react';
import { ErrorBoundary, Scope } from '@sentry/react';
import { TFunction } from 'i18next';
import ErrorBoundaryAlert from './components/ErrorBoundaryAlert';
import { useLocation } from 'react-router-dom';

interface ErrorBoundaryProps {
  t: TFunction;
  children: React.ReactNode;
  beforeCapture?(scope: Scope, error: Error | null, componentStack: string | null): void;
}

/**
 * Error boundary component used to capture errors and display an error Alert
 *
 * @param t - translation function
 * @param children - React component to wrap the error boundary with
 *
 */
const ErrorBoundaryComponent: React.FC<ErrorBoundaryProps> = ({ t, beforeCapture, children }: ErrorBoundaryProps) => {
  const { pathname } = useLocation();

  return (
    <ErrorBoundary
      beforeCapture={beforeCapture}
      fallback={({ error, resetError }) => {
        return (
          <ErrorBoundaryAlert
            title={t('ns.error_page:error')}
            error={error}
            fallbackErrMessage={t('ns.error_page:app_error')}
            resetError={resetError}
            pathname={pathname}
          />
        );
      }}
    >
      {children}
    </ErrorBoundary>
  );
};

export default ErrorBoundaryComponent;
